import React, { useState, useEffect } from "react";
import { Typography, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import LabTestIcon from "../../assets/Icon/LabTestIcon.png";
import CustomCard from "../../components/Famer/GenericCard";
import ConfirmationPopup from "../../components/Popup/GenericPopup";
import { useAlert } from "../../components/Alert";

import { useNavigate } from "react-router-dom";

export default function LabTests() {
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    api
      .get(`/farmer/lab_test/`)
      .then((result) => {
        setData(result.data);
        setLoading(false);
      })
      .catch((err) => {
        alert("Error: " + err.response.data.non_field_errors[0]);
        setLoading(false);
      });
  };
  const handleAddLabTest = () => {
    window.location.href = "/farmer/create-lab-test";
  };
  const handleView = (labId) => {
    navigate(`/farmer/lab-test/${labId}`);
  };
  const handleEditClick = (labId) => {
    navigate(`/farmer/create-lab-test/?labId=${labId}`);
  };
  const handleDelete = (id) => {
    setSelectedMemberId(id);
    setDeleteConfirmationOpen(true);
  };
  const handleConfirmDelete = () => {
    api
      .delete(`/farmer/lab_test/${selectedMemberId}`)
      .then((response) => {
        console.log("Lab Test deleted successfully", response);
        showAlert("success", "Deleted Successfully");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error deleting lab test:", error);
        showAlert("error", "Some issue on Deleting the Farmer");
      });
  };
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: data.length === 0 ? "58vh" : "94vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            // alignItems: "center", // Center items horizontally
          }}
        >
          {data.length !== 0 && (
            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontSize: "30px",
                fontWeight: 700,
                marginTop: "10px",
              }}
            >
              {t("Lab Test")}
            </Typography>
          )}
          <div
            style={{
              overflowY: "auto",
              maxHeight: "calc(115vh - 300px)",
              textAlign: "center",
              height: "700px",
              margin: "auto",
            }}
          >
            {data.map((crop) => (
              <CustomCard
                key={crop.id}
                id={crop.id}
                t={t}
                data={{
                  [t("Lab")]: crop.lab_name,
                  [t("Test Date")]: crop.test_date,
                  [t("Report Data")]: crop.report_date,
                  [t("Remarks")]: crop.remarks,
                }}
                // file={crop.lab_report}
                handleEditClick={() => handleEditClick(crop.id)}
                handlePrimaryButton={handleView}
                handleDelete={() => handleDelete(crop.id)}
              />
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {data.length === 0 && (
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={LabTestIcon}
                  alt="My Crops Icon"
                  style={{
                    width: "127px",
                    height: "127px",
                    marginBottom: "10px",
                  }}
                />
              </div>
            )}
            <CustomButton onClick={handleAddLabTest}>
              {t("Add Lab Test")}
            </CustomButton>
            {data.length === 0 && (
              <Typography
                variant="subtitle1"
                sx={{ mb: 2, textAlign: "center" }}
              >
                {t("Your Crops will be shown here once you add them.")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
      <ConfirmationPopup
        open={deleteConfirmationOpen}
        handleClose={() => setDeleteConfirmationOpen(false)}
        handleConfirm={handleConfirmDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this member?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </>
  );
}
